import api from './api'

/**
 * Serviço de One-on-One (Reuniões 1:1)
 */
export default {
  /**
   * Listar reuniões 1:1
   */
  list(params = {}) {
    return api.get('/api/one-on-ones', { params })
  },

  /**
   * Dashboard/Stats do gestor
   */
  getStats(params = {}) {
    return api.get('/api/one-on-ones/stats', { params })
  },

  /**
   * Status do time (compliance)
   */
  getTeamStatus(params = {}) {
    return api.get('/api/one-on-ones/team-status', { params })
  },

  /**
   * Insights do gestor
   */
  getInsights() {
    return api.get('/api/one-on-ones/insights')
  },

  /**
   * Colaboradores frequentes
   */
  getCollaborators() {
    return api.get('/api/one-on-ones/collaborators')
  },

  /**
   * Tópicos mais discutidos
   */
  getTopics(params = {}) {
    return api.get('/api/one-on-ones/topics', { params })
  },

  /**
   * Taxa de compliance por time
   */
  getCompliance() {
    return api.get('/api/one-on-ones/compliance')
  },

  /**
   * Agendar reunião 1:1
   */
  schedule(meetingData) {
    return api.post('/api/one-on-ones', meetingData)
  },

  /**
   * Atualizar reunião 1:1
   */
  update(id, meetingData) {
    return api.put(`/api/one-on-ones/${id}`, meetingData)
  },

  /**
   * Atualizar tópicos da pauta
   */
  updateTopics(id, topics) {
    return api.put(`/api/one-on-ones/${id}/topics`, { topics })
  },

  /**
   * Atualizar data/hora do agendamento
   */
  updateSchedule(id, scheduledAt) {
    return api.put(`/api/one-on-ones/${id}/schedule`, { scheduledAt })
  },

  /**
   * Cancelar reunião 1:1
   */
  cancel(id, cancellationReason) {
    return api.put(`/api/one-on-ones/${id}/cancel`, { cancellationReason })
  },

  /**
   * Marcar reunião como realizada (occurredAt preenchido pelo backend)
   */
  markAsOccurred(id) {
    return api.put(`/api/one-on-ones/${id}/occurred`)
  },

  /**
   * Salvar link da reunião Microsoft Teams na One-on-One
   * PUT /api/one-on-ones/{id}/meeting-link
   * @param {string} id
   * @param {{ meetingUrl: string, microsoftEventId: string, outlookWebLink: string }} data
   */
  updateMeetingLink(id, data) {
    return api.put(`/api/one-on-ones/${id}/meeting-link`, data)
  },
}
